var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoEarningsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 124,
    viewBox: "0 0 132 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.403 16.8008C140.71 40.1299 134.072 79.0556 104.578 103.743C91.2321 114.915 75.4918 121.257 60.2831 122.691C41.8834 124.425 24.2617 118.976 12.597 106.204C-8.7092 82.8746 -2.07203 43.9495 27.4217 19.2615C56.9154 -5.42653 98.0964 -6.52818 119.403 16.8008Z",
    fill: "#DAE9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3665 73.7965L78.0023 8.83691L112.458 23.1913L85.822 88.1506L51.3665 73.7965Z",
    fill: "#2278FF",
    stroke: "black",
    strokeOpacity: 0.01,
    strokeWidth: 0.00109073,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4872 14.8961L55.5312 70.5278C55.8132 70.54 56.0894 70.5993 56.3386 70.7627C57.1247 71.2787 57.323 72.3891 56.7766 73.2425C56.7546 73.2767 56.7191 73.2927 56.6955 73.3254L82.5821 83.7001C82.6338 83.52 82.6892 83.3414 82.7956 83.175C83.3162 82.3633 84.3156 82.0965 85.0886 82.5161L107.896 26.7594C107.896 26.7594 106.86 26.6744 106.456 25.8311C106.115 25.1187 106.803 24.2313 106.803 24.2313L80.8774 13.2034C80.8774 13.2034 81.1806 14.4558 80.353 15.0252C79.4706 15.6328 78.4872 14.8961 78.4872 14.8961Z",
    fill: "#B4D2FE",
    stroke: "black",
    strokeOpacity: 0.01,
    strokeWidth: 0.00109073,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.307 59.9298C71.7582 57.5856 69.1552 51.0756 71.4922 45.3895C73.8292 39.7034 80.2216 36.9944 85.7696 39.3388C91.3183 41.6831 93.9213 48.193 91.5843 53.8791C89.2473 59.5651 82.855 62.2741 77.307 59.9298Z",
    fill: "#2278FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1862 57.797C73.7911 55.9385 71.7292 50.7772 73.5806 46.2691C75.432 41.7609 80.4958 39.613 84.8909 41.4715C89.2852 43.33 91.3479 48.4912 89.4958 52.9994C87.6444 57.5076 82.5813 59.6555 78.1862 57.797Z",
    fill: "#FFAB22"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2126 50.4102L78.3254 44.7463L79.7474 45.2958L79.2093 47.3037C79.2093 47.3037 79.8971 47.1155 80.3805 47.2651L80.9284 46.0308L81.9202 46.4972L81.5205 47.6229C81.5205 47.6229 83.5254 48.8922 83.1134 50.9477C83.1134 50.9477 86.1785 50.1169 87.5131 50.1797L87.4409 51.705L82.358 52.7877L81.1762 52.2497C81.1762 52.2497 82.4956 49.4841 80.8851 48.7647L79.8143 51.5977L78.6994 51.2101L79.9093 48.3111C79.9093 48.3111 77.8877 48.4366 77.7106 50.9686L76.2126 50.4102Z",
    fill: "#2278FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1107 91.7005L32.7603 22.9744L69.3407 15.55L83.691 84.2761L47.1107 91.7005Z",
    fill: "#2278FF",
    stroke: "black",
    strokeOpacity: 0.01,
    strokeWidth: 0.00109073,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5576 27.7209L48.7281 86.6595C48.9681 86.5113 49.2301 86.4057 49.5281 86.4011C50.4683 86.3875 51.255 87.1969 51.2806 88.2092C51.2817 88.2502 51.2615 88.2837 51.2601 88.3232L78.5132 82.4058C78.4554 82.228 78.4015 82.0494 78.3961 81.8518C78.3718 80.8873 79.0497 80.1068 79.9253 80.0202L67.5631 21.0617C67.5631 21.0617 66.6564 21.5721 65.8493 21.1003C65.1674 20.7017 65.2406 19.5806 65.2406 19.5806L37.5886 24.9792C37.5886 24.9792 38.5415 25.8465 38.1756 26.7818C37.7852 27.7796 36.5576 27.7209 36.5576 27.7209Z",
    fill: "#B4D2FE",
    stroke: "black",
    strokeOpacity: 0.01,
    strokeWidth: 0.00109073,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8214 65.6775C54.9126 66.8456 49.1079 62.9133 47.8563 56.8948C46.6047 50.8759 50.3802 45.0496 56.289 43.8813C62.1979 42.713 68.0024 46.6451 69.2541 52.664C70.5058 58.6828 66.7301 64.5093 60.8214 65.6775Z",
    fill: "#2278FF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3542 63.4181C55.6727 64.343 51.0723 61.224 50.0788 56.4529C49.0852 51.6817 52.0748 47.0647 56.7563 46.1405C61.4377 45.2163 66.0385 48.3349 67.0319 53.106C68.0252 57.8772 65.0356 62.4939 60.3542 63.4181Z",
    fill: "#FFAB22"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5797 58.4068L53.1548 52.532L54.6401 52.1903L55.3203 54.1544C55.3203 54.1544 55.7838 53.6134 56.2684 53.4661L56.0299 52.1371L57.1132 51.9672L57.413 53.1235C57.413 53.1235 59.7846 53.0512 60.5959 54.984C60.5959 54.984 62.6682 52.5782 63.8088 51.8821L64.6037 53.186L61.0011 56.9315L59.7211 57.1484C59.7211 57.1484 59.2636 54.1185 57.5266 54.4253L58.2274 57.3719L57.087 57.6756L56.4645 54.5965C56.4645 54.5965 54.8603 55.8337 56.1327 58.0299L54.5797 58.4068Z",
    fill: "#2278FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8301 58.3613H92.2905C98.9564 58.3613 104.361 63.5752 104.361 70.0071V107.273C104.361 112.419 100.037 116.59 94.7042 116.59H36.8301V58.3613Z",
    fill: "#1560D6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3139 82.4636H104.352V92.4151H86.9012C85.99 92.4151 85.2505 91.7022 85.2505 90.8229V84.4541C85.2505 83.3551 86.1746 82.4636 87.3139 82.4636Z",
    fill: "#438FFE",
    stroke: "black",
    strokeOpacity: 0.01,
    strokeWidth: 0.00273036,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9736 87.5191C87.9736 86.3731 88.8963 85.4443 90.0332 85.4443C91.171 85.4443 92.0928 86.3731 92.0928 87.5191C92.0928 88.6652 91.171 89.5947 90.0332 89.5947C88.8963 89.5947 87.9736 88.6652 87.9736 87.5191Z",
    fill: "white",
    stroke: "black",
    strokeOpacity: 0.01,
    strokeWidth: 0.00273036,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoEarningsIcon);
export default __webpack_public_path__ + "static/media/noEarningsIcon.acfe565767e466579a259c0e36051533.svg";
export { ForwardRef as ReactComponent };